import UserActivationCard from "./CardNote"
import React, { useState, useEffect, useMemo } from 'react';
import { motion } from 'framer-motion';
import axiosInstance from '../../utils/axiosInstanse';
import Spiner from '../Spiner/Spiner'
import host from "../../host";
import './style.css';

function ActivateUser() {

  const [notes, setNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [isError, setIsError] = useState(undefined);

  const filteredData = useMemo(() => {
    if (search === '' || search === undefined) return notes;
    return notes.filter(item => {
      const itemValues = Object.values(item);
      return itemValues.some(value => String(value).includes(search));
    });
  }, [notes, search]);

  useEffect(() => {
    axiosInstance.get(`${host}api/activate/user_activate/`)
      .then(response => {
        const new_data = response.data.map(item => {
          return {
            ...item,
          }
        })
        setNotes(new_data);
        setIsLoading(false);
      })
      .catch(error => {
        if (error.response.status === 403) {
          setIsError(true)
        }
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="au-container">
      {isError ? (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="au-access-denied">
            У вас нет прав для доступа к данному разделу
          </div>
        </motion.div>
      ) : isLoading && isError !== undefined ? (
        <Spiner />
      ) : notes.length > 0 ? (
        <motion.div
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.15 }}
        >

          <div className="au-search-wrap">
            <label className="au-label" htmlFor="auSearch">
              Поиск
            </label>
            <input
              type="text"
              id="auSearch"
              className="au-input"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Введите текст для поиска..."
            />
            <div className="au-hint">Введите критерии поиска</div>
          </div>

          {filteredData.map(note => (
            <UserActivationCard
              key={note.id}
              user={{
                id: note.id,
                tab_num: note.username,
                phone: note.phone_number,
                full_name: note.full_name,
                status: null,
                created_at: note.date_joined
              }}
            />
          ))}

          <div style={{ marginBottom: 70 }}></div>
        </motion.div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <div className="au-empty">Нет записей</div>
        </motion.div>
      )}
    </div>
  );
}

export default ActivateUser;